import { Box } from '@mui/material';
import { node } from 'prop-types';
import React from 'react';

const LinkList = ({ children }) => (
  <Box sx={{ width: '100%', paddingTop: '20px', flexGrow: 1 }}>{children}</Box>
);

LinkList.propTypes = {
  children: node.isRequired,
};

export default LinkList;
